import { useAuth } from '@clerk/clerk-react';
import { useState, useEffect, useCallback } from 'react';

export function useToken() {
    const { getToken } = useAuth();
    const [token, setToken] = useState(null);

    useEffect(() => {
        let mounted = true;
        const refresh = () => {
            getToken()
                .then(t => {
                    // Skip state update (and the re-render cascade) when the token hasn't changed
                    if (mounted) setToken(prev => (prev === t ? prev : t));
                })
                .catch(err => {
                    console.error('Token refresh failed:', err);
                });
        };
        refresh();
        // Proactively refresh — Clerk short-lived JWTs expire quickly
        const interval = setInterval(refresh, 50 * 1000);
        return () => {
            mounted = false;
            clearInterval(interval);
        };
    }, [getToken]);

    return token;
}

// Returns a function that always fetches a fresh token from Clerk.
// Use this in mutations (mark-as-complete, submit project) instead of
// the cached token from useToken, to avoid stale-token 401 errors.
export function useGetFreshToken() {
    const { getToken } = useAuth();
    return useCallback(() => getToken(), [getToken]);
}

export default useToken;
